module.exports = __webpack_public_path__ + "static/media/home-section-image.ce7a92e6.png";